<template>
  <div class="page-wrapper">
    <AppHeader title="API Logs" />
    <div class="container" style="width: 95% !important">
      <div class="container left w-100">
        <div class="row topnav">
          <div class="col-sm-12" style="display: flex; flex-wrap: wrap; gap: 15px; margin-bottom: 20px;">
            
            <!-- Filters -->
            <div style="display: flex; align-items: center;">
              <div class="input-group touch-search-group" style="min-width: 250px;">
                <span class="input-group-addon">
                  <i class="glyphicon glyphicon-user"></i>
                </span>
                <ModelSelect
                  placeholder="Select User"
                  :options="users"
                  v-model="selectedUser"
                  style="color: var(--theme-text-main); background-color: #ffffff14 !important; width: 100%;height: 50px !important"
                />
              </div>
            </div>
            
           <div style="display: flex; align-items: center;">
             <div class="input-group touch-search-group" style="min-width: 200px;">
              <span class="input-group-addon">
                <i class="glyphicon glyphicon-th-list"></i>
              </span>
              <input type="text" v-model="filters.page" placeholder="Page" class="form-control input-lg" />
            </div>
           </div>
            
           <div style="display: flex; align-items: center;">
             <div class="input-group touch-search-group" style="min-width: 250px;">
              <span class="input-group-addon">
                <i class="glyphicon glyphicon-cog"></i>
              </span>
              <ModelSelect
                placeholder="Select Operation"
                :options="operations"
                v-model="selectedOperation"
                style="color: var(--theme-text-main); background-color: #ffffff14 !important; width: 100%;height: 50px !important"

              />
            </div>
           </div>

            <div class="input-group touch-search-group">
              <span class="input-group-addon">
                <i class="glyphicon glyphicon-calendar"></i>
              </span>
              <input type="date" v-model="filters.startDate" class="form-control input-lg" />
            </div>

            <div class="input-group touch-search-group">
              <span class="input-group-addon">
                <i class="glyphicon glyphicon-calendar"></i>
              </span>
              <input type="date" v-model="filters.endDate" class="form-control input-lg" />
            </div>

            <div style="display: flex;gap: 10px;">
              <button class="btn btn-success btn-lg" @click="getLogs()">
                Search
              </button>
              <button class="btn btn-default btn-lg" @click="resetFilters()">
                Reset
              </button>
            </div>
          </div>
        </div>

        <div v-if="!loading">
          <div class="row table-wrap" style="color: #fff;">
            <table class="table" style="color: #fff">
              <thead>
                <tr>
                  <th style="font-size: 1.2em">ID</th>
                  <th style="font-size: 1.2em">User ID</th>
                  <th style="font-size: 1.2em">Username</th>
                  <th style="font-size: 1.2em">Page</th>
                  <th style="font-size: 1.2em">Operation</th>
                  <th style="font-size: 1.2em">Action</th>
                  <th style="font-size: 1.2em">Created At</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="log in allLogs" :key="log.id">
                  <td style="font-size: 1.2em">{{ log.id }}</td>
                  <td style="font-size: 1.2em">{{ log.userId }}</td>
                  <td style="font-size: 1.2em">{{ log.username }}</td>
                  <td style="font-size: 1.2em">{{ log.page }}</td>
                  <td style="font-size: 1.2em">{{ log.operation }}</td>
                  <td style="font-size: 1.2em; max-width: 300px; overflow: hidden; text-overflow: ellipsis;" title="{{ log.action }}">{{ log.action }}</td>
                  <td style="font-size: 1.2em">{{ log.created_at }}</td>
                </tr>
              </tbody>
            </table>
            <ul class="pagination">
              <li class="page-item" :class="{ disabled: page === 1 }">
                <a class="page-link" href="#" @click="goToPage(page - 1)">Previous</a>
              </li>

              <li v-if="page > 3">
                <a class="page-link" href="#" @click="goToPage(1)">1</a>
              </li>

              <li v-if="page > 4">
                <span class="page-link">...</span>
              </li>

              <li
                v-for="pageNumber in visiblePages"
                :key="pageNumber"
                :class="{ active: page === pageNumber }"
              >
                <a class="page-link" href="#" @click="goToPage(pageNumber)">{{
                  pageNumber
                }}</a>
              </li>

              <li v-if="page < totalPages - 3">
                <span class="page-link">...</span>
              </li>

              <li v-if="page < totalPages - 2">
                <a class="page-link" href="#" @click="goToPage(totalPages)">{{
                  totalPages
                }}</a>
              </li>

              <li class="page-item" :class="{ disabled: page === totalPages }">
                <a class="page-link" href="#" @click="goToPage(page + 1)">Next</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import AppHeader from "@/components/AppHeader";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";

export default {
  components: { AppHeader, ModelSelect },
  computed: {
    totalPages() {
      if (this.totalLength) {
        return Math.ceil(this.totalLength / 15);
      }
      return 0;
    },
    visiblePages() {
      let startPage = Math.max(1, this.page - 2);
      let endPage = Math.min(this.totalPages, startPage + 4);

      if (endPage - startPage < 4) {
        startPage = Math.max(1, endPage - 4);
      }

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    }
  },
  mixins: [commonServices],
  mounted() {
    this.getLogs();
    this.getUsers();
    this.getOperations();
    if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
    } else {
      this.$router.push({ name: "login" });
    }
  },
  data: function () {
    return {
      page: 1,
      loading: false,
      allLogs: [],
      totalLength: 0,
      users: [],
      operations: [],
      selectedUser: null,
      selectedOperation: null,
      filters: {
        appId: "",
        userId: "",
        searchUsername: "",
        page: "",
        operation: "",
        action: "",
        startDate: "",
        endDate: ""
      }
    };
  },
  watch: {
    selectedUser(newVal) {
      console.log("watch selectedUser newVal:", newVal);
      this.page = 1;
    },
    selectedOperation(newVal) {
      console.log("watch selectedOperation newVal:", newVal);
      this.filters.operation = newVal ? (typeof newVal === 'object' ? newVal.value : newVal) : '';
      this.page = 1;
    }
  },
  methods: {
    resetFilters() {
      this.filters = {
        appId: "",
        userId: "",
        searchUsername: "",
        page: "",
        operation: "",
        action: "",
        startDate: "",
        endDate: ""
      };
      this.selectedUser = null;
      this.selectedOperation = null;
      this.page = 1;
      this.getLogs();
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.page = page;
        this.getLogs();
      }
    },
    getLogs: async function () {
      this.loading = true;
      try {
        // Build payload manually
        const payload = {
          appId: localStorage.appId,
          offset: (this.page - 1) * 15
        };

        // Add searchID if selectedUser exists
        if (this.selectedUser) {
          payload.searchID = typeof this.selectedUser === 'object' ? this.selectedUser.value : this.selectedUser;
        }

        // Add operation if selectedOperation exists
        if (this.selectedOperation) {
          payload.operation = typeof this.selectedOperation === 'object' ? this.selectedOperation.value : this.selectedOperation;
        }

        // Add page filter if present
        if (this.filters.page) {
          payload.page = this.filters.page;
        }

        // Add searchUsername filter if present
        if (this.filters.searchUsername) {
          payload.searchUsername = this.filters.searchUsername;
        }

        // Add startDate and endDate if present
        if (this.filters.startDate) {
          payload.startDate = this.filters.startDate;
        }
        if (this.filters.endDate) {
          payload.endDate = this.filters.endDate;
        }

        console.log("getLogs payload (manual):", payload);

        let dataURL = this.apiURL + "ApiLogs/getAllLogs";
        let response = await axios.post(dataURL, payload);
        console.log("getLogs response:", response.data);
        if (response.data.status === "success") {
          this.allLogs = response.data.results;
          this.totalLength = response.data.total_length;
        }
      } catch (error) {
        console.log("getLogs error:", error);
      }
      this.loading = false;
    },

    getUsers: async function () {
      try {
        let url = this.apiURL + "ApiLogs/getAllUsers";
        let response = await axios.post(url, {
          appId: localStorage.appId
        });
        console.log("getUsers response:", response.data);
        if(response.data.status === "success"){
          this.users = response.data.results.map(user => ({
            value: user.id,
            text: user.username
          }));
          console.log("this.users after mapping:", this.users);
        }
      } catch(error){
        console.log("getUsers error:", error);
      }
    },
    getOperations: async function () {
      try {
        let url = this.apiURL + "ApiLogs/getAllOperations";
        let response = await axios.post(url, {
          appId: localStorage.appId
        });
        console.log("getOperations response:", response.data);
        if(response.data.status === "success"){
          this.operations = response.data.results.map(op => ({
            value: op.id,
            text: op.name
          }));
          console.log("this.operations after mapping:", this.operations);
        }
      } catch(error){
        console.log("getOperations error:", error);
      }
    },
  }
};
</script>

<style>
/* Style for vue-search-select to ensure text is black */
.vue-search-select {
  color: black !important;
}
.vue-search-select .vs__search {
  color: black !important;
}
.vue-search-select .vs__dropdown-menu {
  color: black !important;
}
.vue-search-select .vs__dropdown-option {
  color: black !important;
}
.vue-search-select .vs__dropdown-option--highlight {
  color: black !important;
}
.vue-search-select .vs__selected {
  color: black !important;
}

.pagination {
  justify-content: center;
  gap: 6px;
}

.pagination .page-item {
  list-style: none;
}

.pagination .page-link {
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  color: #fff;
  border-radius: 8px;
  padding: 6px 12px;
  min-width: 40px;
  margin: 2px;
  text-align: center;
  transition: all 0.2s ease;
}

.pagination .page-link:hover {
  background: var(--form-color);
  border-color: var(--theme-primary);
  color: #fff;
  transform: translateY(-2px);
}

.pagination .active .page-link {
  background: linear-gradient(135deg, var(--theme-primary), var(--theme-secondary));
  border-color: var(--theme-accent);
  color: #fff;
  font-weight: 600;
  box-shadow: 0 4px 12px var(--theme-bg-end);
}

.pagination .disabled .page-link {
  opacity: 0.4;
  pointer-events: none;
}

.pagination .page-link {
  text-decoration: none;
}
</style>
